export const getRovoChatProduct = (): string => {
	let product = 'UNKNOWN';
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	if (window && (window as any).__ROVO_CHAT_CONFIG_PRODUCT__) {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		product = (window as any).__ROVO_CHAT_CONFIG_PRODUCT__;
	}
	return product;
};
